import Image from 'next/image';
import { LinkButton } from '../LinkButton/LinkButton';

interface Expert {
  name: string;
  jobTitle: string;
  profileImage: string;
}

interface Props {
  heading: string;
  body: string;
  expert: {
    value: { data: Expert };
  };
  link?: string;
}

export const ExpertProfile: React.FC<Expert> = ({ profileImage, name, jobTitle }) => {
  return (
    <div className="mr-10 flex w-full gap-4 md:flex-col md:items-center md:justify-center">
      <div className="h-16 w-16 overflow-hidden rounded-full md:h-25 md:w-25">
        <Image
          src={profileImage}
          alt="A picture of one of our experts in the temporary insurance market"
          width={100}
          height={100}
        />
      </div>
      <div className="flex flex-col justify-center md:text-center">
        <p className="mt-0 mb-2 font-semibold">{name}</p>
        <p className="font-base mt-0 mb-0">{jobTitle}</p>
      </div>
    </div>
  );
};

export const ExpertQuote = ({ heading, body, expert, link }: Props) => {
  if (!heading || !body || !expert) return null;

  return (
    <>
      <div className="md:flex">
        <div className="hidden items-center justify-center md:flex md:w-[30%]">
          <ExpertProfile
            name={expert.value.data.name}
            jobTitle={expert.value.data.jobTitle}
            profileImage={expert.value.data.profileImage}
          />
        </div>
        <div className="flex flex-1 flex-col justify-center">
          <h2 className="mt-0 mb-4">{heading}</h2>
          <p className="mb-4">{body}</p>
          <div className="mb-4 block md:hidden">
            <ExpertProfile
              name={expert.value.data.name}
              jobTitle={expert.value.data.jobTitle}
              profileImage={expert.value.data.profileImage}
            />
          </div>
          {link && <LinkButton link={link} label={'Get a quote'} size={'medium'} variant={'primary'} />}
        </div>
      </div>
    </>
  );
};
